export default class BrowserUtil {

	private static EASING = {
		linear: (t: number) => t,
		easeInOutQuad: (t: number) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
	};

	public static copyToClipboard(str: string) {
		// Create new element
		const el = document.createElement('textarea');
		// Set value (string to be copied)
		el.value = str;
		// Set non-editable to avoid focus and move outside of view
		el.setAttribute('readonly', '');
		el.setAttribute('style', "position: absolute; left: -9999px");
		document.body.appendChild(el);
		// Select text inside element
		el.select();
		// Copy text to clipboard
		document.execCommand('copy');
		// Remove temporary element
		document.body.removeChild(el);
	}

	public static scrollContainer(target: HTMLElement, container: HTMLElement, offset: number = 0, duration: number = 300) {
		const distance = target.offsetTop - (container.offsetTop + container.scrollTop) - offset;

		if (distance === 0) {
			return;
		}

		const dur = duration > 300 ? duration : 300;
		const size = distance / (dur / 10);

		let i = 0;
		const interval = setInterval(() => {
			i += 10;
			container.scrollTop += size;
			if (i >= dur) {
				clearInterval(interval);
			}
		}, 10);
	}
}

export const copyToClipboard = BrowserUtil.copyToClipboard;



// WEBPACK FOOTER //
// ./src/core/util/BrowserUtil.ts